import React, { useState, useEffect, useRef } from "react";

const API_URL = "/api";

export default function TelegramChat() {
  const [chats, setChats] = useState([]);
  const [messages, setMessages] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const [fullImage, setFullImage] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
	fetch(`${API_URL}/chats`)
	  .then((res) => res.json())
	  .then((data) => setChats(data))
	  .catch((err) => console.error("Ошибка загрузки чатов", err));
  }, []);

  const loadMessages = async (chatId) => {
	setSelectedChat(chatId);
	try {
	  const res = await fetch(`${API_URL}/messages/${chatId}`);
	  const data = await res.json();
	  setMessages(data);
	} catch (err) {
	  console.error("Ошибка загрузки сообщений", err);
	}
  };

  const sendMessage = async () => {
	if (!selectedChat || !newMessage.trim()) return;
	try {
	  const res = await fetch(`${API_URL}/send`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ chatId: selectedChat, message: newMessage }),
	  });
	  const data = await res.json();
	  if (data.success) {
		setNewMessage("");
		await loadMessages(selectedChat);
	  } else {
		console.error("Ошибка при отправке сообщения", data.error);
	  }
	} catch (err) {
	  console.error("Ошибка при отправке сообщения", err);
	}
  };

  // 🔹 Отправить файл
  const sendFile = async (file) => {
	if (!selectedChat || !file) return;
	const formData = new FormData();
	formData.append("chatId", selectedChat);
	formData.append("file", file);
	try {
	  const res = await fetch(`${API_URL}/send-file`, {
		method: "POST",
		body: formData,
	  });
	  const data = await res.json();
	  if (data.success) {
		await loadMessages(selectedChat);
	  } else {
		console.error("Ошибка при отправке файла", data.error);
	  }
	} catch (err) {
	  console.error("Ошибка при отправке файла", err);
	}
  };

  // 🔹 Обработка drag-and-drop
  const handleDrop = (e) => {
	e.preventDefault();
	if (e.dataTransfer.files.length > 0) {
	  sendFile(e.dataTransfer.files[0]);
	}
  };

  return (
	<div
	  className="flex h-screen bg-gray-100"
	  onDragOver={(e) => e.preventDefault()}
	  onDrop={handleDrop}
	>
	  {fullImage && (
		<div className="fixed inset-0 bg-black bg-opacity-80 flex flex-col items-center justify-center z-50" onClick={() => setFullImage(null)}>
		  <div className="absolute top-5 right-5">
			<a href={fullImage} download className="text-white bg-gray-800 px-4 py-2 rounded-lg hover:bg-gray-700 transition">
			  📥 Скачать
			</a>
		  </div>
		  <img src={fullImage} alt="Full View" className="max-w-full max-h-full" />
		</div>
	  )}

	  {/* Список чатов */}
	  <div className="w-1/4 bg-white border-r overflow-y-auto">
		<h2 className="text-lg font-bold p-4 border-b">Чаты</h2>
		{chats.map((chat) => (
		  <div
			key={chat.id}
			className={`chat-item flex items-center space-x-3 p-3 cursor-pointer hover:bg-gray-200 transition duration-200 ease-in-out rounded-md ${
			  selectedChat === chat.id ? "chat-selected bg-blue-200" : ""
			}`}
			onClick={() => loadMessages(chat.id)}
		  >
			<div className="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center text-xl font-semibold text-white">
			  {chat.name[0]}
			</div>
			<span className="text-lg truncate w-40">{chat.name}</span>
		  </div>
		))}
	  </div>

	  {/* Окно чата */}
	  <div className="w-3/4 flex flex-col">
		{/* Заголовок */}
		<div className="bg-white p-4 border-b flex items-center justify-between">
		  <h2 className="text-lg font-bold">
			{chats.find((chat) => chat.id === selectedChat)?.name || "Выберите чат"}
		  </h2>
		  <button
			onClick={() => fileInputRef.current.click()}
			className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 transition"
		  >
			📎 Прикрепить файл
		  </button>
		  <input
			type="file"
			ref={fileInputRef}
			style={{ display: "none" }}
			onChange={(e) => {
			  if (e.target.files.length > 0) {
				sendFile(e.target.files[0]);
			  }
			}}
		  />
		</div>

		{/* Сообщения */}
		<div className="flex-1 overflow-y-auto p-4 space-y-2 flex flex-col">
		  {messages.length === 0 ? (
			<p className="text-gray-500 text-center">Нет сообщений</p>
		  ) : (
			messages.map((msg) => (
			  <div
				key={msg.id}
				className="message fade-in max-w-md p-3 rounded-lg break-words shadow-md bg-gray-300 text-black self-start text-left mr-auto rounded-bl-lg"
			  >
				{msg.file ? (
				  msg.file.match(/\.(jpg|jpeg|png|gif)$/i) ? (
					<img
					  src={msg.file}
					  alt="file"
					  className="max-w-xs rounded-lg cursor-pointer hover:scale-110 transition"
					  onClick={() => setFullImage(msg.file)}
					/>
				  ) : (
					<div className="flex flex-col items-start">
					  <a
						href={msg.file}
						download
						className="text-blue-600 underline flex items-center space-x-2"
					  >
						📎 Скачать файл ({msg.file.split("/").pop()})
					  </a>
					  {msg.file.match(/\.pdf$/i) && (
						<iframe
						  src={msg.file}
						  className="w-full h-40 border mt-2"
						  title="PDF Preview"
						></iframe>
					  )}
					</div>
				  )
				) : (
				  msg.text || "[Нет текста]"
				)}
			  </div>
			))
		  )}
		</div>

		{/* Форма отправки */}
		<div className="p-4 bg-white border-t flex">
		  <input
			type="text"
			className="chat-input flex-1 p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all"
			value={newMessage}
			onChange={(e) => setNewMessage(e.target.value)}
			placeholder="Введите сообщение"
			onKeyDown={(e) => e.key === "Enter" && sendMessage()}
		  />
		  <button onClick={sendMessage} className="send-button ml-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all">
			➤
		  </button>
		</div>
	  </div>
	</div>
  );
}
